<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 px-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="trophy"></b-icon>
              Projektabschluss
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- HELP ICON  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              href="https://www.bauvisor.de/projektabschluss/"
              target="_blank"
            >
              <b-icon icon="question-circle" variant="dark" class=""></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas" style="max-width: 1000px">
      <b-alert :show="projectStore.activeProject.State == 2" variant="info">
        <b-icon scale="1.3" class="mr-2" icon="info-circle" />
        Projekt ist archiviert und kann nicht mehr bearbeitet werden.
      </b-alert>
      <!--

        
        State
          0: Kalkulation
          1: Ausführung
          2: Archiviert
          3: Beendet
          4: Gelöscht
      -->
      <!-- Abschnitt "Projekt beenden" -->
      <div class="row">
        <div class="col">
          <h5>Projekt beenden</h5>
          <hr class="mt-0" />
        </div>
      </div>

      <div class="mt-1">
        Auf ein beendetes Projekt kann nicht mehr zugegriffen werden.
        <br />
        <br />
        <div v-if="projectStore.activeProject.IsDemo == false">
          Ihr Kundenadministrator wird über Ihre Anfrage informiert und muss den Vorgang bestätigen.
          <br />
          <br />
          Das Projekt kann vom Kundenadministrator entweder
          <br />
          &nbsp;•&nbsp;&nbsp;archiviert (alle Projektbeteiligten erhalten weiterhin Lesezugiff) oder
          <br />
          &nbsp;•&nbsp;&nbsp;gelöscht (nach Ablauf einer Reaktivierungsfrist werden die Daten komplett vom Server aus
          Datenschutzgründen entfernt) werden
          <br />
          <br />
        </div>
        <div v-else>
          Ihr Demoprojekt wird hiermit beendet und ihr Benutzerkonto deaktiviert.
          <br />
          <br />
        </div>
        <div class="mt-1" v-if="hasEndRequest == false">
          <b-button
            @click="endProject"
            class="mr-2"
            tag="button"
            variant="danger"
            :disabled="projectStore.activeProject.State > 1"
            v-if="
              ($root.$user.isAdmin || $root.$user.isSuperAdmin || $root.$user.mayEnd) &&
                (projectStore.activeProject.State == 0 ||
                  projectStore.activeProject.State == 1 ||
                  projectStore.activeProject.State == 2)
            "
          >
            <b-icon icon="archive" class="pr-1" />
            Projekt "
            <strong>{{ projectStore.activeProject.Name }}</strong>
            " beenden
          </b-button>
        </div>
        <div v-if="hasEndRequest && projectStore.activeProject.IsDemo == false" class="mt-3">
          <b-alert info show>
            <b-icon icon="info-circle" scale="1.3" class="mr-2" />
            Es wurde am
            <strong>{{ $utils.SQLDateToGermanDate(projectStore.activeProject.HasEndRequests) }}</strong>
            angefordert, dieses Projekt zu beenden.
            <span class="float-right">
              <b-icon scale="0.8" class="mr-1" icon="chevron-right"></b-icon>
              <b-link class="text-secondary" @click="cancelProjectEndRequest">Abbrechen</b-link>
            </span>
          </b-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import projectStore from '@/store/Projects';
import projectService from '@/service/ProjectsService';

export default {
  data() {
    return {
      projectStore,
      hasEndRequest: false
    };
  },
  activated() {
    this.hasEndRequest =
      projectStore.activeProject.HasEndRequests != null && projectStore.activeProject.HasEndRequests != 'null';
    AppState.isLoading = false;
  },

  methods: {
    async archiveProject() {
      const messageVNode = this.$createElement('div', {
        domProps: {
          innerHTML: `Sie beenden damit die aktive Projektarbeit. Das Projekt wird archiviert und alle User haben weiterhin Lesezugriff.<br><br><span class="text-danger font-weight-bold">Es fallen Kosten gemäß Kostenvereinbarung an.<br><br>Eine Reaktivierung des Projekts ist nur durch den BauVisor Kundensupport möglich.<br><br></span><h5>Soll das Projekt <strong>"${projectStore.activeProject.Name}"</strong> wirklich werden?</h5>`
        }
      });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Projekt archivieren',
          okTitle: 'Archivieren',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(async confirmed => {
          if (confirmed) {
            await projectService.archive();
            this.$showSuccess(
              this,
              'Projekt archivieren',
              'Projekt "' + projectStore.activeProject.Name + '" erfolgreich archiviert.'
            );
            projectStore.activeProject.State = 2;
            this.$eventBus.$emit('projectSwitched', projectStore.activeProject);
          }
        });
    },
    async endProject() {
      const messageVNode = this.$createElement('div', {
        domProps: {
          innerHTML: `Soll die Beedingung des Projekts <strong>"${projectStore.activeProject.Name}"</strong> beim Kundenadministrator beantragt werden?`
        }
      });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Projekt beenden',
          okTitle: 'Projekt beenden',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(async confirmed => {
          if (confirmed) {
            this.projectStore.activeProject.HasEndRequests == 'true';
            this.hasEndRequest = true;
            await projectService.end();
            projectStore.activeProject.HasEndRequests = new Date();
            this.$showSuccess(
              this,
              'Projekt beenden',
              'Projekt "' + projectStore.activeProject.Name + '" erfolgreich beendet.'
            );
            //projectStore.activeProject.State = 3;
            //this.$eventBus.$emit('projectSwitched', projectStore.projects[0]);
            //this.$router.push('/completion/end');
            if (this.projectStore.activeProject.IsDemo) this.$router.push('/completion/end');
          }
        });
    },
    async unarchiveProject() {
      this.$bvModal
        .msgBoxConfirm(
          'Soll die Archivierung des Projekts "' +
            projectStore.activeProject.Name +
            '" wirklich rückgängig gemacht werden?',
          {
            title: 'Projekt archivieren',
            okTitle: 'Un-Archivieren',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          }
        )
        .then(async confirmed => {
          if (confirmed) {
            try {
              await projectService.unarchive();
              this.$showSuccess(
                this,
                'Projekt archivieren',
                'Projekt "' + projectStore.activeProject.Name + '" erfolgreich zurückgesetzt.'
              );
              projectStore.activeProject.State = 1;
              this.$eventBus.$emit('projectSwitched', projectStore.activeProject);
            } catch (err) {
              if (err.response) this.$showError(this, err.response.data.error);
              else this.$showError(this, err.toString());
            }
          }
        });
    },
    cancelProjectEndRequest() {
      this.$bvModal
        .msgBoxConfirm('Soll der Antrag auf Löschung des Projekts widerrufen werden?', {
          title: 'Projektlöschung abbrechen',
          okTitle: 'Widerrufen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(async confirmed => {
          if (confirmed) {
            projectService
              .abortEnd()
              .then(() => {
                projectStore.activeProject.HasEndRequests = null;
                this.hasEndRequest = false;
                this.$showSuccess(
                  this,
                  'Projekt beenden',
                  'Der Löschantrag für das Projekt "' +
                    projectStore.activeProject.Name +
                    '" wurde erfolgreich widerrufen.'
                );
              })
              .catch(err => this.$showError(this, JSON.stringify(err)));
          }
        });
    }
  }
};
</script>

<style scoped>
.page-header {
  border-bottom: 1px solid #dee2e6;
}
</style>
